import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import MaterialTable from '@material-table/core';
import flowRight from 'lodash.flowright';

import { mapTableOptions } from '../../../consts/tableOptions';
import useTableLocalization from '../../../utils/useTableLocalization';
import { actions as reduxActions } from '../reducers';
import FilterButton from '../../../partials/tableCustomButtons/FilterButton';
import tableColumns from './tableColumns';
import useLocalTableStore from '../../../utils/useLocalTableStore';
import getOrders from '../actions/getOrders';
import { translate } from '../../../i18n/I18nProvider';
import customTableIcons from '../../../partials/tableIcons/customTableIcons';
import getIdFromUrl from '../../../utils/getIdfromUrl';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { isDefined } from '../../../utils/isDefined';
import OrdersTableHeader from './OrdersTableHeader';
import RefreshButton from '../../../partials/tableCustomButtons/RefreshButton';

const OrdersTable = ({
  orders,
  columns,
  setColumns,
  getOrders,
  location,
  filteredBy,
  isLoading
}) => {
  const [filtering, setFiltering] = useState(false);
  const client = useMemo(() => getIdFromUrl(location), [location]);
  const [refresh, setRefresh] = useState(false);
  const { localization, language } = useTableLocalization();

  useEffect(() => {
    getOrders(client);
    // eslint-disable-next-line
  }, [client]);

  const tableDefaultColumns = useMemo(() => {
    return tableColumns(client);
  }, [client]);

  const tableName = isDefined(client) ? 'Orders-1.5' : 'Order-admin-1.5';

  const {
    pageSize,
    onChangeRowsPerPage,
    onChangeColumnHidden
  } = useLocalTableStore({
    tableName,
    setColumns,
    tableDefaultColumns,
    language
  });

  useEffect(() => {
    if (refresh) {
      getOrders(client);
      setRefresh(false);
    }
    // eslint-disable-next-line
  }, [refresh]);

  const actions = useMemo(
    () => [
      {
        icon: () => <FilterButton />,
        onClick: () => {
          setFiltering(!filtering);
        },
        isFreeAction: true,
        tooltip: translate('BUTTON.FILTER')
      },
      {
        icon: () => <RefreshButton tableHeader={true} />,
        onClick: () => setRefresh(true),
        isFreeAction: true
      }
    ],
    // eslint-disable-next-line
    [filtering]
  );

  const options = useMemo(() => {
    return {
      ...mapTableOptions({ exportData: false }),
      selection: false,
      filtering,
      pageSize
    };
  }, [filtering, pageSize]);

  const filteredOrders = useMemo(() => {
    if (filteredBy === 'all') {
      return orders;
    }

    return orders.filter(order => order.status === filteredBy);
  }, [orders, filteredBy]);

  return (
    <>
      <MaterialTable
        isLoading={isLoading}
        title={<OrdersTableHeader />}
        icons={customTableIcons}
        actions={actions}
        columns={columns}
        data={filteredOrders}
        options={options}
        localization={localization}
        onChangeColumnHidden={onChangeColumnHidden}
        onRowsPerPageChange={onChangeRowsPerPage}
      />
    </>
  );
};

const mapStatesToProps = ({ orders, loader }) => {
  return {
    ...orders,
    isLoading: loader.isSpinVisible
  };
};

const mapDispatchToProps = {
  getOrders,
  setColumns: reduxActions.setColumns
};

export default flowRight(
  withRouter,
  connect(mapStatesToProps, mapDispatchToProps)
)(OrdersTable);
